// extracted by mini-css-extract-plugin
module.exports = {"classes":"Classes_classes__IeMVs","datetime":"Classes_datetime__nf5QM","time":"Classes_time__OzehZ"};